import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import React from 'react';

import styles from './styles';

const SubscriptionError = () => {
  const handleGoToHome = () => {
    // Altere conforme sua navegação (ex: window.location.href = '/', useRouter, etc.)
    window.location.href = '/';
  };

  return (
    <Box sx={styles.container}>
      <Card sx={styles.card}>
        <CardContent sx={styles.content}>
          <ErrorOutlineIcon color="error" sx={styles.icon} />
          <Typography variant="h4" sx={styles.title}>
            Algo deu errado!
          </Typography>
          <Typography variant="body1" sx={styles.message}>
            Não conseguimos processar sua assinatura.
            <br />
            Tente novamente ou entre em contato com nosso suporte.
          </Typography>
          <Button
            variant="contained"
            color="error"
            sx={styles.button}
            onClick={handleGoToHome}
          >
            Voltar para o início
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SubscriptionError;
